import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../base_svg-icon/component';
import Text from '@text';
import './styles.scss';

const Usp = ({ icon = 'default', text = '', textKey = '', children }) => {
  const map = {
    error: { name: 'ico-error', color: 'error' },
    check: { name: 'ico-check', color: 'success' },
    info: { name: 'ico-info-filled', color: 'info' },
    default: { name: 'ico-check', color: 'success' },
  };
  const lineIcon = icon ? map[icon] : false;

  return (
    <div className="usp">
      {lineIcon && (
        <div>
          <Icon className={lineIcon.color} size={100} name={lineIcon.name} />
        </div>
      )}

      {children ? children : (
        <>
          {textKey ? (
            <p className="usp-label">
              <Text html>{textKey}</Text>
            </p>
          ) : (
            <p className="usp-label" dangerouslySetInnerHTML={{ __html: text }} />
          )}
        </>
      )}
    </div>
  );
};

Usp.propTypes = {
  text: PropTypes.string,
  textKey: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node,
};

export default Usp;
